// extracted by mini-css-extract-plugin
export default {"suggestionsBar":"scheme-select_suggestionsBar__NYts_","imageArea":"scheme-select_imageArea__kpCcD","schemeSuggestion":"scheme-select_schemeSuggestion__nAnN8"};